export const ON_SALE_FILTER_DATA_TEST_ID = 'on-sale-filter'
